module.exports = __webpack_public_path__ + "static/media/random.6c1ab615.svg";